import { render, staticRenderFns } from "./ApiaryList.vue?vue&type=template&id=510bcf3c&scoped=true&"
import script from "./ApiaryList.vue?vue&type=script&lang=js&"
export * from "./ApiaryList.vue?vue&type=script&lang=js&"
import style0 from "./ApiaryList.vue?vue&type=style&index=0&id=510bcf3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510bcf3c",
  null
  
)

export default component.exports